export const getStatusStyle = (status) => {
  switch (status) {
    case "Draft" :
    case "On Hold":
      return { backgroundColor: "#f1f5f9", color: "#4b5563" }; // abu-abu terang, teks abu-abu
    case "To Deliver and Bill":
      return { backgroundColor: "#e0f2fe", color: "#1d4ed8" }; // biru terang, teks biru
    case "To Bill":
      return { backgroundColor: "#d1fae5", color: "#047857" }; // hijau terang, teks hijau
    case "To Deliver":
      return { backgroundColor: "#fef08a", color: "#b45309" }; // kuning terang, teks kuning
    case "Completed":
      return { backgroundColor: "#d1fae5", color: "#047857" }; // hijau terang, teks hijau
    case "Cancelled":
      return { backgroundColor: "#fef2f2", color: "#ef4444" }; // merah terang, teks merah
    case "Closed":
      return { backgroundColor: "#f1f5f9", color: "#4b5563"  }; // abu terang, teks abu
    default:
      return { backgroundColor: "#e0f2fe", color: "#1d4ed8" }; // default biru terang, teks biru
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // bulan dari 0
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
